var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.57422 2C5.56182 2 4.70909 2.75652 4.58847 3.76171L3.92988 9.25H20.0699L19.4113 3.76171C19.2907 2.75652 18.4379 2 17.4255 2H6.57422Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2499 10.75H3.74988L3.26847 14.7617C3.1424 15.8123 3.85152 16.7518 4.844 16.9581L1.40004 21.55C1.15152 21.8814 1.21867 22.3515 1.55004 22.6C1.88142 22.8485 2.35152 22.7814 2.60004 22.45L3.87504 20.75H20.125L21.4 22.45C21.6486 22.7814 22.1187 22.8485 22.45 22.6C22.7814 22.3515 22.8486 21.8814 22.6 21.55L19.156 16.958C20.1484 16.7516 20.8573 15.8122 20.7313 14.7617L20.2499 10.75ZM19 19.25H5.00004L6.68754 17H17.3125L19 19.25ZM17.9999 13.5C17.9999 14.3284 17.3283 15 16.4999 15C15.6714 15 14.9999 14.3284 14.9999 13.5C14.9999 12.6716 15.6714 12 16.4999 12C17.3283 12 17.9999 12.6716 17.9999 13.5ZM7.49988 15C6.67145 15 5.99988 14.3284 5.99988 13.5C5.99988 12.6716 6.67145 12 7.49988 12C8.3283 12 8.99988 12.6716 8.99988 13.5C8.99988 14.3284 8.3283 15 7.49988 15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainAlt1);
export default __webpack_public_path__ + "static/media/train-alt-1.c337085b66da7907032fbab6492f69f5.svg";
export { ForwardRef as ReactComponent };